"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using HTML comments (`<!--` `-->`).
 * Matches tags of the form `<!--variable-->` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello <!--variable-->';
 * const result = replaceTags(text, { variable: 'world' }, HTMLComments);
 * console.log(result); // Output: 'Hello world'
 */
var HTMLComments = {
    name: "HTML Comments",
    openingTag: "<!--",
    closingTag: "--!>",
    tagPattern: /<!--.*?--!>/g,
    tagStartPattern: /^<!--/,
    tagEndPattern: /--!>$/,
};
exports.default = HTMLComments;
